import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Loader2, ImageOff } from "lucide-react";
import { Col, Row } from "reactstrap"; // Import Row và Col để chia 4 cột
import imgcacao from "../../assets/images/cacao.png";
import "./blog-list.css";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // --- Logic phân trang ---
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const location = useLocation();
  const blogsPerPage = 8; // Hiển thị 8 bài mỗi trang (2 dòng, mỗi dòng 4 bài)

  const createSlug = (title) => {
    return title
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[đĐ]/g, "d")
      .replace(/([^0-9a-z-\s])/g, "")
      .replace(/(\s+)/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  // Đồng bộ page từ URL
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get("page");
    setPage(pageParam ? Number(pageParam) : 0);
  }, [location]);

  useEffect(() => {
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          "https://dht.api.mekongzone.com.vn/api/tintuc"
        );
        const sortedBlogs = response.data.reverse();
        setBlogs(sortedBlogs);
        setPageCount(Math.ceil(sortedBlogs.length / blogsPerPage));
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  const changePage = (pageNumber) => {
    setPage(pageNumber);
    // Cập nhật URL giống logic bên TypeProduct
    window.history.pushState(null, "", `/blog?page=${pageNumber}`);
    window.scrollTo(0, 0); // Cuộn lên đầu trang khi chuyển trang
  };

  // Lấy danh sách bài viết của trang hiện tại
  const currentPageBlogs = blogs.slice(page * blogsPerPage, (page + 1) * blogsPerPage);

  const getCategoryName = (slug) => {
    const map = {
      "bai-hoc": "Bài học",
      "ky-thuat": "Kỹ thuật",
      "cong-thuc": "Công thức",
      "huong-dan": "Hướng dẫn",
      "cau-chuyen": "Câu chuyện",
      "dinh-duong": "Dinh dưỡng",
      "suc-khoe": "Sức khỏe",
      khac: "Tin tức",
    };
    return map[slug] || "Blog";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("vi-VN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading)
    return (
      <div className="loading-container">
        <Loader2 className="animate-spin" size={40} />
        <span style={{ marginLeft: 10 }}>Đang tải bài viết...</span>
      </div>
    );

  return (
    <>
      <div
        className="blog-list-hero"
        style={{ width: "100%", height: "364px", backgroundColor: "#FBB042" }}
      >
        <div className="content-blog-list-hero">
          <img src={imgcacao} alt="" />
          <div className="content">
            <h1 className="content-blog-list-hero-title">BLOG.</h1>
            <div>
              <p className="content-blog-list-hero-desc">
                Nơi chia sẻ kiến thức, nghệ thuật thưởng thức
              </p>
              <p className="content-blog-list-hero-desc">
                và những “bí mật” đằng sau hương vị sô cô la thượng hạng.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="blog-list-container container mt-5">
        <Row className="blog-grid">
          {currentPageBlogs.map((blog) => {
            const coverImage =
              blog.hinhanhs && blog.hinhanhs.length > 0 ? blog.hinhanhs[0] : null;
            const blogLink = `/blog/${blog.id}-${createSlug(blog.tieude)}`;

            return (
              <Col lg="3" md="6" sm="12" key={blog.id} className="mb-4 blog__card">
                <div className="blog-card h-100">
                  <Link to={blogLink} className="card-image-wrapper">
                    {coverImage ? (
                      <img
                        src={coverImage}
                        alt={blog.tieude}
                        className="blog-image"
                        loading="lazy"
                      />
                    ) : (
                      <div
                        className="blog-image"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#f3f4f6",
                          color: "#9ca3af",
                        }}
                      >
                        <ImageOff size={40} />
                      </div>
                    )}
                    <span className="category-badge">
                      {getCategoryName(blog.danhmuc)}
                    </span>
                  </Link>

                  <div className="card-content">
                    <Link to={blogLink} style={{ textDecoration: "none" }}>
                      <h2 className="blog-title" title={blog.tieude}>
                        {blog.tieude}
                      </h2>
                    </Link>
                    <p className="blog-desc">{blog.mota}</p>
                    <div className="card-footer">
                      <span style={{ fontSize: "0.85rem", color: "#9ca3af" }}>
                        {formatDate(blog.ngaydang)}
                      </span>
                      <Link to={blogLink} className="read-more">
                        Đọc tiếp <ArrowRight size={16} />
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>

        {/* Phân trang - Copy logic style từ TypeProduct */}
        <Row>
          <Col lg="12">
            <div className="pagination d-flex align-items-center justify-content-center mt-4 gap-3 mb-5">
              {[...Array(pageCount).keys()].map((number) => (
                <span
                  className={page === number ? "active__page" : ""}
                  key={number}
                  onClick={() => changePage(number)}
                  // style={{ 
                  //   cursor: "pointer",
                  //   padding: "5px 12px",
                  //   border: "1px solid #ccc",
                  //   borderRadius: "4px" 
                  // }}
                >
                  {number + 1}
                </span>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default BlogList;